import type { IndustryContent } from '@/types/content';

export const garageDoorContent: IndustryContent = {
  slug: 'garage-door',
  name: 'Garage Door',
  headline: 'The Operating System for Garage Door Companies',
  subheadline:
    'Dispatch faster, track parts inventory, and close more sales—all from one platform built for garage door pros.',
  heroImageUrl: '/images/industries/garagedoor-hero.webp',
  painPoints: [
    {
      title: 'Emergency calls are chaos',
      description:
        'When a customer is stuck in their garage at 6am, finding the nearest available tech with the right parts takes too long.',
      icon: 'emergency',
    },
    {
      title: 'Parts inventory is a mystery',
      description:
        "Springs, rollers, and openers are scattered across trucks and warehouses. You don't know what's in stock until you need it.",
      icon: 'inventory',
    },
    {
      title: 'Sales opportunities slip away',
      description:
        "Techs diagnose issues but don't have tools to present upgrade options. You're leaving money on the table every call.",
      icon: 'sales',
    },
    {
      title: 'Warranty tracking is manual',
      description:
        "You're looking through paper files to figure out if a customer's opener is still under warranty. It wastes everyone's time.",
      icon: 'warranty',
    },
  ],
  features: [
    {
      title: 'Smart Dispatch Board',
      description:
        'See tech locations, truck inventory, and availability at a glance. Dispatch the right tech with the right parts in minutes.',
      icon: 'dispatch',
    },
    {
      title: 'Truck Inventory Tracking',
      description:
        'Track springs, cables, openers, and parts on every truck. Auto-replenish alerts keep techs stocked and ready.',
      icon: 'inventory',
    },
    {
      title: 'On-Site Sales Tools',
      description:
        'Techs present good/better/best options with photos and pricing. Digital quotes convert to jobs with one tap.',
      icon: 'sales',
    },
    {
      title: 'Equipment & Warranty Tracking',
      description:
        'Track every door, opener, and spring at every customer location. Warranty lookups take seconds, not minutes.',
      icon: 'warranty',
    },
    {
      title: 'Photo Documentation',
      description:
        'Before/after photos attached to every job. Protect your business and show customers the value of your work.',
      icon: 'camera',
    },
    {
      title: 'Mobile-First Experience',
      description:
        'Full job details, customer history, and payment processing on the go. Works even in garages with weak signal.',
      icon: 'mobile',
    },
  ],
  testimonial: {
    id: 'garagedoor-1',
    quote:
      'Our average ticket went up 35% after we started using the on-site sales tools. Techs love showing customers their options on the tablet instead of trying to explain everything verbally.',
    author: 'Kevin O\'Brien',
    role: 'Owner',
    company: 'O\'Brien Garage Doors',
    industry: 'garage-door',
    stats: {
      label: 'Average Ticket Increase',
      value: '35%',
    },
  },
  stats: [
    { label: 'Faster Emergency Response', value: '40%' },
    { label: 'Average Ticket Increase', value: '35%' },
    { label: 'Parts Availability', value: '98%' },
    { label: 'First-Call Resolution', value: '+30%' },
  ],
  seo: {
    title: 'Garage Door Software | Dispatch & Service Management | Omniforge',
    description:
      'Garage door service software built for pros. Smart dispatch, inventory tracking, on-site sales tools, and mobile app. Start your free trial.',
    keywords: [
      'garage door software',
      'garage door service software',
      'garage door dispatch software',
      'garage door business software',
      'garage door scheduling software',
    ],
  },
};
